import React, {
  useEffect,
  useState,
} from "react";
import axios from "axios";
import {
  Box,
  Tab,
  Tabs,
} from "@mui/material";

import { API_URL } from "../components/api";
import InventoryTable from "./InventoryTable";
import WarehouseTable from "./WarehouseTable";

function TabPanel({
  children,
  value,
  index,
}) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`inventory-tabpanel-${index}`}
      aria-labelledby={`inventory-tab-${index}`}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `inventory-tab-${index}`,
    "aria-controls": (
      `inventory-tabpanel-${index}`
    ),
  };
}

export default function InventoryTabs() {
  const [value, setValue] = useState(0);
  const [warehouses, setWarehouses] = (
    useState([])
  );
  const [loading, setLoading] = (
    useState(true)
  );
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;

    const fetchWarehouses = async () => {
      try {
        setLoading(true);
        setError("");

        const authTokens = JSON.parse(
          localStorage.getItem("authTokens")
          || "{}"
        );

        const response = await axios.get(
          `${API_URL}/inventory/transfer/warehouses/`,
          {
            headers: {
              Authorization: (
                `Bearer ${authTokens.access}`
              ),
            },
          }
        );

        if (!active) {
          return;
        }

        const rows = Array.isArray(
          response.data
        )
          ? response.data
          : [];

        rows.sort(
          (first, second) => (
            Number(first.warehouse_id)
            - Number(second.warehouse_id)
          )
        );

        setWarehouses(rows);
      } catch (requestError) {
        if (!active) {
          return;
        }

        setError(
          requestError.response?.data?.detail
          || "Unable to load warehouses."
        );
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    fetchWarehouses();

    return () => {
      active = false;
    };
  }, []);

  const handleChange = (
    event,
    newValue
  ) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Inventory warehouses"
          textColor="inherit"
          variant="scrollable"
          scrollButtons="auto"
          TabIndicatorProps={{
            style: {
              backgroundColor: "white",
            },
          }}
        >
          <Tab
            label="Inventory"
            {...a11yProps(0)}
            sx={{ color: "white" }}
          />

          {warehouses.map(
            (warehouse, warehouseIndex) => (
              <Tab
                key={warehouse.warehouse_id}
                label={warehouse.warehouse_name}
                {...a11yProps(
                  warehouseIndex + 1
                )}
                sx={{ color: "white" }}
              />
            )
          )}
        </Tabs>
      </Box>

      <TabPanel value={value} index={0}>
        <InventoryTable />
      </TabPanel>

      {loading && (
        <Box sx={{ p: 3, color: "white" }}>
          Loading warehouses...
        </Box>
      )}

      {error && (
        <Box
          sx={{
            p: 3,
            color: "#ff8f8f",
          }}
        >
          {error}
        </Box>
      )}

      {!loading && warehouses.map(
        (warehouse, warehouseIndex) => (
          <TabPanel
            key={warehouse.warehouse_id}
            value={value}
            index={warehouseIndex + 1}
          >
            <WarehouseTable
              id={warehouse.warehouse_id}
              name={warehouse.warehouse_name}
            />
          </TabPanel>
        )
      )}
    </Box>
  );
}
